import { IUpdateGrupoAcessoUseCase } from "../../../presentation/useCases/update/update_grupo_acesso_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * UpdateGrupoAcessoUseCase
 */

export class UpdateGrupoAcessoUseCase implements IUpdateGrupoAcessoUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(
    idGrupoAcesso: number,
    nomeGrupo?: string | null,
    descricao?: string | null,
    ativo?: boolean | null,
    idFuncionario?: number | null,

    idsAtribuicaoGrupo?: number[]
  ): Promise<void> {
    await this.repository.updateGrupoAcesso(
      idGrupoAcesso,
      nomeGrupo,
      descricao,
      ativo,
      idFuncionario,

      idsAtribuicaoGrupo
    );

  }
}
